import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { useLanguage } from '@sona/angular-util-common';
import { ENVIRONMENT } from '@sona/angular-util-environment';

import { SubscriptionService } from '../services/subscription.service';

@Component({
    selector: 'sona-pricing-table-page',
    template: `
        <div class="tw-flex tw-flex-col tw-items-center tw-mb-12">
            <h1 class="tw-text-center tw-max-w-[40rem] tw-mb-8">
                {{ 'PAYMENTS.PAGE.PRICING_TABLE.TITLE' | translate }}
            </h1>

            <div class="tw-max-w-3xl tw-mx-auto tw-text-muted-foreground tw-text-base tw-rounded-full tw-py-2 tw-px-4 tw-bg-muted">
                {{ 'PAYMENTS.PAGE.PRICING_TABLE.LAUNCH_DISCOUNT.0' | translate }} <strong class="tw-text-[#0061ff]">33%</strong> {{ 'PAYMENTS.PAGE.PRICING_TABLE.LAUNCH_DISCOUNT.1' | translate }} 
                <span class="tw-bg-[#0d1f3b] tw-py-1.5 tw-px-2.5 tw-rounded-full tw-text-white tw-ml-0.5 tw-text-sm tw-font-bold -tw-mr-2">LAUNCH</span>
            </div>
        </div>

        <stripe-pricing-table
            [attr.pricing-table-id]="pricingTable()"
            [attr.publishable-key]="options.publishableKey"
            [attr.customer-session-client-secret]="customerSession.value()?.client_secret"
        ></stripe-pricing-table>

        <div class="tw-max-w-[50rem] tw-mx-auto tw-p-4 tw-text-xs tw-text-muted-foreground">
            <ul class="tw-m-0 tw-p-4">
                @for (line of 'PAYMENTS.PAGE.PRICING_TABLE.FOOTNOTES' | translate; track line) {
                    <li class="tw-mb-2 last:tw-mb-0">{{ line }}</li>
                }
            </ul>
        </div>
    `,
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    imports: [
        TranslatePipe
    ],
    host: {
        class: 'tw-block tw-h-full tw-p-8 dot-pattern'
    }
})
export class SonaPricingTablePage {

    protected readonly options = inject(ENVIRONMENT).payments;
    protected readonly customerSession = inject(SubscriptionService).getCustomerSession();
    private readonly language = useLanguage();

    protected readonly pricingTable = computed(() => {
        const language = (this.language() as 'de' | 'en') ?? 'en';

        return this.options.pricingTables[language] ?? this.options.pricingTables.en;
    });
}
